export interface ISerologyTracking {
     id: number,
     recipientId: number,
     donorId: number,
     clusterNumber: number,
     chainNumber: number,
     positionNumber: number,
     statusId: number,
     status: string,
     statusDeadline: string,
     requestedDate: string,
     requestedTests: string,
     serologyShipMethod: number,
     shipOutDate: string,
     shipOutOnTime: boolean,
     shipOutTrackingNumber: string,
     shipOutOperatorId: string,
     receivedDate: string,
     receivedOnTime: boolean,
     remoteSendDate: string,
     remoteSendOnTime: boolean,
     remoteSendTrackingNumber: string,
     shipBackDate: string,
     shipBackOnTime: boolean,
     shipBackTrackingNumber: string,
     receivedBackDate: string,
     receivedBackOnTime: boolean,
     resultsSentDate: string,
     resultsSentOnTime: boolean,
     targetSurgeryDate: string,

     surgeryDate: null,

     donationCenterId: number,
     donorCenterId: number,
     donorCenter: string,
     rdnCenterId: number,
     rdnCenter: string,
     
     donorAlias: string,

     recipientCenterId: number,
     recipientCenter: string,
     
     recipientAlias: string,
     
     showMarkedReceived: boolean,
     showShippedToRemoteDonor: boolean,
     showSerologyTestsShippedBack: boolean,
     showSerologyTracking: boolean
}
